// offline/proGate.js — EL CANDADO PRO del estudio sin conexión (D-G, F6.7b).
//
// La regla de negocio firmada: estudiar SIN SEÑAL es una capacidad de Pro. Con
// señal, todos los planes estudian como siempre y nadie se entera de que este
// archivo existe.
//
// LA REGLA DURA, y es la que gobierna todo lo demás: LA DUDA SE RESUELVE A
// FAVOR DEL USUARIO. Si el tier local no existe, no se pudo leer, o llegó
// ilegible, el candado DEJA PASAR. Un usuario Pro al que un dato faltante le
// niega su material offline es un fallo del producto; un usuario Free que
// estudia una vez de más no le cuesta nada a nadie. Por eso este módulo nunca
// lanza y su default es siempre `allow`.
//
// Función pura: sin imports, sin efectos, sin red, sin bodega. El tier lo
// consigue el llamador (del snapshot de usuario que F6.4b ya escribe en cada
// login/refresh de perfil — cero storage nuevo).

export const GATE_VARIANT = {
  FREE: 'free',   // cuenta registrada sin Pro → pantalla de venta con CTA a /upgrade
  GUEST: 'guest', // invitado → misma venta, rematada con "crea tu cuenta"
};

// Los planes que TIENEN estudio sin conexión. Cualquier cosa fuera de esta
// lista que no sea un plan conocido cae al lado del usuario (ver abajo).
const PRO_PLANS = ['pro', 'premium'];
// Los planes que NO lo tienen, nombrados explícitamente. Un plan desconocido
// (uno nuevo que este build no conoce todavía) NO se bloquea: solo se bloquea
// lo que sabemos con certeza que no está incluido.
const NON_PRO_PLANS = ['free'];

/**
 * evaluateOfflineProGate — ¿puede esta persona iniciar sesión de estudio AHORA?
 *
 * @param {{offline: boolean, appBuild: boolean, tier: {plan?: string, is_guest?: boolean}|null}} input
 *   - offline: DICTAMEN del vigía (no sospecha). Con cualquier otra cosa que
 *     no sea un `offline` recibido, esto es false y el candado ni se evalúa.
 *   - appBuild: en web el candado no existe.
 *   - tier: el plan local conocido, o null si no hay/no se pudo leer.
 *
 * @returns {{allow: boolean, variant?: 'free'|'guest', reason: string}}
 *   `reason` es para el visor de diagnóstico y los tests; la UI solo mira
 *   `allow` y `variant`.
 */
export function evaluateOfflineProGate(input) {
  const { offline = false, appBuild = false, tier = null } = input || {};

  if (!appBuild) return { allow: true, reason: 'web' };
  // Con señal (o sin dictamen) el candado no aplica: Free estudia normal y
  // jamás ve la pantalla de venta.
  if (!offline) return { allow: true, reason: 'con-red' };

  // REGLA DURA: sin dato, pasa.
  if (!tier || typeof tier !== 'object') return { allow: true, reason: 'sin-tier' };

  if (tier.is_guest === true) {
    return { allow: false, variant: GATE_VARIANT.GUEST, reason: 'guest' };
  }

  const plan = typeof tier.plan === 'string' ? tier.plan.trim().toLowerCase() : '';
  if (!plan) return { allow: true, reason: 'plan-ilegible' };
  if (PRO_PLANS.includes(plan)) return { allow: true, reason: 'pro' };
  if (NON_PRO_PLANS.includes(plan)) {
    return { allow: false, variant: GATE_VARIANT.FREE, reason: 'free' };
  }
  // Plan que este build no conoce: la duda es del build, no del usuario.
  return { allow: true, reason: 'plan-desconocido' };
}
